import {DeviceParamLirisV3TriggerData} from "./device-param-liris-v3-trigger-data";

export class DeviceParamLirisV3Thresold {
    public min: DeviceParamLirisV3TriggerData[] = [];
    public max: DeviceParamLirisV3TriggerData[] = [];
}
